<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="backToPromoServices()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <!-- <h5 class="card-title font-weight-bold font-size-lg mb-4">Contract Service</h5> -->
            <div *ngIf="showForm">
            <form [formGroup]="promoForm">
                <div class="row">
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label for="empid">Contract ID As Promo Code*</label>
                                <input id="empid" class="form-control" [readonly]="editPromo" 
                                formControlName="contractID" placeholder="Contract ID As Promo Name" type="text" 
                                [ngClass]="{'is-invalid': submitted && f.contractID.errors}"  
                                (input)="convertToUpperCase($event)">
                                <div *ngFor="let validation of validation_messages.contractID">
                                    <div class="error-message" *ngIf="f.contractID.hasError(validation.type) && ((f.contractID.dirty  || f.contractID.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-3 col-sm-6">
                            <div class="position-relative form-group">
                                <label for="empid">Contract Type*</label>
                                <ng-select id="contractType" [readonly]="editPromo" formControlName="contractType" [(ngModel)]="selectedContractType" [ngClass]="{'is-invalid': submitted && f.contractType.errors}" placeholder="Select contract type">
                                    <ng-option *ngFor="let contractType of contractTypes" [value]="contractType.ContractID">{{contractType.ContractID}} </ng-option>
                                </ng-select>
                                <div *ngFor="let validation of validation_messages?.contractType">
                                    <div class="error-message" *ngIf="f.contractType.hasError(validation.type) && ((f.contractType.dirty  || f.contractType.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group">
                                <label for="empid">Discount(%)*</label>
                                <input id="amount" class="form-control" formControlName="discount_percent" placeholder="Discount(%) " type="number" [ngClass]="{'is-invalid': submitted && f.discount_percent.errors}">
                                <div *ngFor="let validation of validation_messages.discount_percent">
                                    <div class="error-message" *ngIf="f.discount_percent.hasError(validation.type) && ((f.discount_percent.dirty  || f.discount_percent.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="form-group col-md-3" *ngIf="!editPromo">
                            <label for="inputEmail4">Effective Start Date</label>
    
                            <input id="effectsDate" [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true}" 
                            bsDatepicker  formControlName="effectsDate" class="form-control"
                            placeholder="Select start date">
                           
                            <div *ngFor="let validation of validation_messages.effectsDate">
                                <div class="error-message"
                                    *ngIf="f.effectsDate.hasError(validation.type) && 
                                                                       ((f.effectsDate.dirty ||  f.effectsDate.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3" >
                            <label for="inputEmail4">Promo Code Description</label>
                            <textarea class="form-control" formControlName="description" placeholder="Promo Code Description" type="number" [ngClass]="{'is-invalid': submitted && f.description.errors}">
                        </textarea>
                           
                            <!-- <div *ngFor="let validation of validation_messages.effectsDate">
                                <div class="error-message"
                                    *ngIf="f.effectsDate.hasError(validation.type) && 
                                                                       ((f.effectsDate.dirty ||  f.effectsDate.touched))">
                                    {{validation.message }}
                                </div>
                            </div> -->
                        </div>
                        <div class="col-md-3 col-sm-6" *ngIf="editPromo">
                            <div class="form-group">
                                <label for="empid">Status*</label>
                                <ng-select  id="active" required formControlName="active" [ngClass]="{'is-invalid': submitted && f.active.errors}" placeholder="Select Status">
                                    <ng-option *ngFor="let status of statusTypes" [value]="status.id">
                                        {{status.name}}
                                    </ng-option>
                                </ng-select>
                            </div>
                        </div>
                   </div>
            <div>
                <b>Note : We are taking the service amounts from Retail - 2022 and applying discounts according to the provided discount rates.</b>
            </div>
                    <div class="row">
                        <div class="col-md-12 py-3">
                            <!-- <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button> -->
                            <button id="saveContractBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddPromoContract(promoForm.value)" *ngIf="!editPromo">Add Promotional Services</button>
                            <!-- <button id="updateContractBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateContract(contractForm.value)" *ngIf="isEditMode">Update Contract </button> -->
                            <!-- <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button> -->
                        </div>
                    </div>
    
           
            </form>
            </div>
            <div *ngIf="showUrlBox">
                <div style="text-align: center;">
                    <h5><b> Promotional services added successfully!</b></h5>
                   </div>
                <div style="padding-left: 10px;"> 
                    <h6><b>PROMO CODE INFO</b></h6>
                </div>
              <div>
                <div class="row">
                    <div class="col-4" style="margin-left: 5px;">
                      CODE
                    </div>
                    <div class="col-4" style="margin-left: 5px;">
                        WEB URL
                    </div>
                   </div>
                   <div class="row pt-3">
                    <div class="col-2 promo-code-box" style="margin-left: 15px; font-size: 18px;">
                        {{promoCodeValue}}
                    </div>
                    <div class="col-6 promo-code-box flex-grow-1" style="margin-left: 17%; font-size: 18px;">
                      {{urlValue}}
                        <button class="copy-icon "
                        (click)="copyToClipboard(urlValue)"
                        >
                            📋
                        </button>
                    </div>
                   </div>
              </div>
            </div>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>